namespace Nobox.Nobox.Pages {
    export interface campaignGroup {
        In?: string;
        Count?: number;
    }
}
